export default "__VITE_ASSET__3e08e9ee__"